var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Complex, Collection } from '@syncfusion/ej2-base';
import { Theme } from './theme';
/**
 * Sets and gets the options to customize the text in heatmap.
 */
export class Font extends ChildProperty {
}
__decorate([
    Property('16px')
], Font.prototype, "size", void 0);
__decorate([
    Property('')
], Font.prototype, "color", void 0);
__decorate([
    Property('Segoe UI')
], Font.prototype, "fontFamily", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontWeight", void 0);
__decorate([
    Property('Normal')
], Font.prototype, "fontStyle", void 0);
__decorate([
    Property('Center')
], Font.prototype, "textAlignment", void 0);
__decorate([
    Property('Trim')
], Font.prototype, "textOverflow", void 0);
/**
 * Sets and gets the options to configures the margins of the heatmap.
 */
export class Margin extends ChildProperty {
}
__decorate([
    Property(10)
], Margin.prototype, "left", void 0);
__decorate([
    Property(10)
], Margin.prototype, "right", void 0);
__decorate([
    Property(10)
], Margin.prototype, "top", void 0);
__decorate([
    Property(10)
], Margin.prototype, "bottom", void 0);
/**
 * Sets and gets the options to customize the borders in the heatmap.
 */
export class Border extends ChildProperty {
}
__decorate([
    Property('')
], Border.prototype, "color", void 0);
__decorate([
    Property(1)
], Border.prototype, "width", void 0);
__decorate([
    Property('')
], Border.prototype, "radius", void 0);
/**
 * Sets and gets the options to customize the tooltip borders in the heatmap.
 */
export class TooltipBorder extends ChildProperty {
}
__decorate([
    Property('')
], TooltipBorder.prototype, "color", void 0);
__decorate([
    Property(0)
], TooltipBorder.prototype, "width", void 0);
/**
 * Sets and gets the options to configure the mapping value for size and color in bubble cell type.
 */
export class BubbleData extends ChildProperty {
}
__decorate([
    Property(null)
], BubbleData.prototype, "size", void 0);
__decorate([
    Property(null)
], BubbleData.prototype, "color", void 0);
/**
 * Sets and gets the options to customize the title of heatmap.
 */
export class Title extends ChildProperty {
}
__decorate([
    Property('')
], Title.prototype, "text", void 0);
__decorate([
    Complex({}, Font)
], Title.prototype, "textStyle", void 0);
/**
 * Sets and gets the options to apply the fill color value for cell color range.
 */
export class FillColor extends ChildProperty {
}
__decorate([
    Property('#eeeeee')
], FillColor.prototype, "minColor", void 0);
__decorate([
    Property('#eeeeee')
], FillColor.prototype, "maxColor", void 0);
/**
 * Sets and gets the options to customize palette colors.
 */
export class PaletteCollection extends ChildProperty {
}
__decorate([
    Property(null)
], PaletteCollection.prototype, "value", void 0);
__decorate([
    Property(null)
], PaletteCollection.prototype, "color", void 0);
__decorate([
    Property(null)
], PaletteCollection.prototype, "label", void 0);
__decorate([
    Property(null)
], PaletteCollection.prototype, "startValue", void 0);
__decorate([
    Property(null)
], PaletteCollection.prototype, "endValue", void 0);
__decorate([
    Property(null)
], PaletteCollection.prototype, "minColor", void 0);
__decorate([
    Property(null)
], PaletteCollection.prototype, "maxColor", void 0);
/**
 * Sets and gets the options to customize the label border.
 */
export class AxisLabelBorder extends ChildProperty {
}
__decorate([
    Property('#b5b5b5')
], AxisLabelBorder.prototype, "color", void 0);
__decorate([
    Property(1)
], AxisLabelBorder.prototype, "width", void 0);
__decorate([
    Property('Rectangle')
], AxisLabelBorder.prototype, "type", void 0);
/**
 * Sets and gets the options to customize the size of the bubble heatmap cell type.
 */
export class BubbleSize extends ChildProperty {
}
__decorate([
    Property('0%')
], BubbleSize.prototype, "minimum", void 0);
__decorate([
    Property('100%')
], BubbleSize.prototype, "maximum", void 0);
/**
 * Sets and gets the options to configure the multi-level labels.
 */
export class MultiLevelCategories extends ChildProperty {
}
__decorate([
    Property(null)
], MultiLevelCategories.prototype, "start", void 0);
__decorate([
    Property(null)
], MultiLevelCategories.prototype, "end", void 0);
__decorate([
    Property('')
], MultiLevelCategories.prototype, "text", void 0);
__decorate([
    Property(null)
], MultiLevelCategories.prototype, "maximumTextWidth", void 0);
/**
 * Sets and gets the options to customize the multi-level labels.
 */
export class MultiLevelLabels extends ChildProperty {
}
__decorate([
    Property('Center')
], MultiLevelLabels.prototype, "alignment", void 0);
__decorate([
    Property('Wrap')
], MultiLevelLabels.prototype, "overflow", void 0);
__decorate([
    Complex(Theme.axisLabelFont, Font)
], MultiLevelLabels.prototype, "textStyle", void 0);
__decorate([
    Complex({ color: '#b5b5b5', width: 1, type: 'Rectangle' }, AxisLabelBorder)
], MultiLevelLabels.prototype, "border", void 0);
__decorate([
    Collection([], MultiLevelCategories)
], MultiLevelLabels.prototype, "categories", void 0);
/**
 * Internal class used to maintain colorcollection.
 *
 * @private
 */
export class ColorCollection {
    constructor(value, color, label, startValue, endValue, minColor, maxColor) {
        this.value = value;
        this.color = color;
        this.label = label;
        this.startValue = startValue;
        this.endValue = endValue;
        this.minColor = minColor;
        this.maxColor = maxColor;
    }
}
/**
 * Specifies the current data of the bubble cell.
 */
export class BubbleTooltipData {
    /**
     * @param {string} mappingName - Specifies the mapping name.
     * @param {number} bubbleData - Specifies the bubble data.
     * @param {string} valueType - Specifies the value type.
     * @private
     */
    constructor(mappingName, bubbleData, valueType) {
        this.mappingName = mappingName;
        this.bubbleData = bubbleData;
        this.valueType = valueType;
    }
}
/**
 * Internal class used to maintain legend colorcollection.
 *
 * @private
 */
export class LegendColorCollection {
    constructor(value, color, label, startValue, endValue, minColor, maxColor, isHidden) {
        this.value = value;
        this.color = color;
        this.label = label;
        this.startValue = startValue;
        this.endValue = endValue;
        this.minColor = minColor;
        this.maxColor = maxColor;
        this.isHidden = isHidden;
    }
}
/**
 * class used to maintain xAxis labels details for multipleRow label intersect action.
 *
 * @private
 */
export class MultipleRow {
    constructor(start, end, index, label, row) {
        this.index = 1;
        this.row = 1;
        this.start = start;
        this.end = end;
        this.index = index;
        this.label = label;
        this.row = row;
    }
}
